// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "sequence_step".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { sequenceStepTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "sequence_step" table (1:1 with a DB row, on the wire). */
export const sequenceStepAtomSchema = z.object({
    id: z.string(),
    sequenceId: z.string(),
    nodeId: z.string(),
    type: z.enum(sequenceStepTypeValues),
    config: z.unknown(),
    order: z.number(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=sequenceStep.js.map